import { boardServices } from 'src/services';
import { Dispatch, FC, SetStateAction } from 'react';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { Modal } from 'react-bootstrap';
import { typeBoardItem, typeBoardSection } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode, useGetShowingLoadingModal } from 'src/custom-hooks';

type propsType = {
    closeModal: () => void;
    section: typeBoardSection;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
};

export const BoardSectionsItemsArchivedFilesModal: FC<propsType> = ({ closeModal, section, setRefreshCounter }) => {
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const showingLoadingModal = useGetShowingLoadingModal();

    const downloadFile = async (file: typeBoardItem, openingNewTab: boolean): Promise<void> => {
        if (showingLoadingModal) {
            return;
        }
        dispatch(showLoadingModalReducer());
        const response = await boardServices.GetArchivedFile(section.title, file, openingNewTab);
        dispatch(hideLoadingModalReducer());
        if (!response.success) {
            dispatch(setAlertResponse({ response }));
        }
    }

    const unarchiveFile = async (file: typeBoardItem): Promise<void> => {
        if (showingLoadingModal) {
            return;
        }
        dispatch(showLoadingModalReducer());
        const response = await boardServices.ArchiveFile(section.id, section.title, file, true);
        dispatch(hideLoadingModalReducer());
        dispatch(setAlertResponse({ response }));
        if (!response.success) {
            return;
        }
        setRefreshCounter(x => x + 1);
    }

    const deleteFile = async (file: typeBoardItem): Promise<void> => {
        if (showingLoadingModal) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: 'Confirmar',
            message: `Se va a eliminar el PDF archivado '${file.originalName}' de la sección '${section.title}'. Esta acción es irreversible.`
        }));
        dispatch(showLoadingModalReducer());
        const response = await boardServices.DeleteItem(section.id, section.title, file);
        dispatch(hideLoadingModalReducer());
        dispatch(setAlertResponse({ response }));
        if (!response.success) {
            return;
        }
        setRefreshCounter(x => x + 1);
    }

    return (
        <Modal show
            size={'lg'}
            onHide={closeModal}
        >
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <Modal.Title>PDFs archivados de '{section.title}'</Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark' : ''}>
                <div className={'table-responsive pb-3'}>
                    <table className={`table ${isDarkMode ? 'table-dark' : 'table-light'}`}>
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Fecha</th>
                                <th className={'text-center'}>Abrir en otra pestaña</th>
                                <th className={'text-center'}>Descargar</th>
                                <th className={'text-center'}>Desarchivar</th>
                                <th className={'text-center'}>Eliminar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!!section.items.filter(i => i.type === 'file' && i.archived).length ?
                                section.items.filter(i => i.type === 'file' && i.archived).map(f =>
                                    <tr key={f.bucketName}>
                                        <td className={'text-nowrap'}>
                                            {f.originalName}
                                        </td>
                                        <td className={'text-nowrap'}>
                                            {new Date(f.createdAt).toLocaleString()}
                                        </td>
                                        <td className={'text-center'}>
                                            <button className={'btn btn-general-red'}
                                                onClick={() => downloadFile(f, true)}
                                                disabled={showingLoadingModal   }
                                            >
                                                Abrir
                                            </button>
                                        </td>
                                        <td className={'text-center'}>
                                            <button className={'btn btn-general-red'}
                                                onClick={() => downloadFile(f, false)}
                                                disabled={showingLoadingModal   }
                                            >
                                                Descargar
                                            </button>
                                        </td>
                                        <td className={'text-center'}>
                                            <button className={'btn btn-general-red'}
                                                onClick={() => unarchiveFile(f)}
                                                disabled={showingLoadingModal   }
                                            >
                                                Desarchivar
                                            </button>
                                        </td>
                                        <td className={'text-center'}>
                                            <button className={'btn btn-general-red'}
                                                onClick={() => deleteFile(f)}
                                                disabled={showingLoadingModal   }
                                            >
                                                Eliminar
                                            </button>
                                        </td>
                                    </tr>
                                )
                                :
                                <tr>
                                    <td colSpan={1000}>No hay ningún PDF archivado</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
            <Modal.Footer className={isDarkMode ? 'bg-dark' : ''}>
                <button className={'btn btn-secondary'} onClick={closeModal}>
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal>
    );
}
